import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import { MatFormFieldModule} from "@angular/material/form-field";
import { MatSelectModule} from "@angular/material/select";
import { MatInputModule} from "@angular/material/input";
import { MatMenuModule} from "@angular/material/menu";
import { ReactiveFormsModule} from "@angular/forms";
import {TimePeriodInputComponent} from "./time-period-input/time-period-input.component";
import { MatSliderModule} from "@angular/material/slider";
@NgModule({
  declarations: [TimePeriodInputComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSliderModule,
  ],
  exports: [TimePeriodInputComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TimeRangePickerModule {
}
